import { render, staticRenderFns } from "./TransactionData.vue?vue&type=template&id=07a0a083&scoped=true"
import script from "./TransactionData.vue?vue&type=script&lang=js"
export * from "./TransactionData.vue?vue&type=script&lang=js"
import style0 from "./TransactionData.vue?vue&type=style&index=0&id=07a0a083&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07a0a083",
  null
  
)

export default component.exports